import {convertPrereleaseConfiguration} from './schema-v1.js';

export function optionCounts(configuration) {
  if (configuration?.schemaVersion !== undefined) {
    try { configuration = convertPrereleaseConfiguration(configuration); }
    catch { return {options: 0, choices: 0}; }
  }
  const shopifyOptions = configuration?.shopifyOptions || [];
  const customOptions = configuration?.customOptions || [];
  return {
    options: shopifyOptions.length + customOptions.length,
    choices: shopifyOptions.reduce((sum, option) => sum + (option.optionValueIds || []).length, 0)
      + customOptions.reduce((sum, option) => sum + (option.choices || []).length, 0),
  };
}
